import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '@context/CartContext';
import CartSidebar from '@components/cart/CartSidebar';

const TICKER_ITEMS = [
  'ॐ नमः शिवाय','Free Shipping over ₹999','Pay via UPI · GPay · PhonePe',
  'Hare Krishna Hare Rama','Certified Astro Stones','Handcrafted God Idols','Vasudhaiva Kutumbakam',
];

export default function Header() {
  const { itemCount } = useCart();
  const navigate = useNavigate();
  const [cartOpen, setCartOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [customerName, setCustomerName] = useState(null);

  useEffect(() => {
    const checkSession = () => {
      const token = localStorage.getItem('customer_token');
      if (token) {
        try {
          const data = JSON.parse(localStorage.getItem('customer_data') || '{}');
          setCustomerName(data.name ? data.name.split(' ')[0] : 'Account');
        } catch {
          setCustomerName('Account');
        }
      } else {
        setCustomerName(null);
      }
    };
    checkSession();
    // Re-check whenever localStorage changes (login/logout in another tab)
    window.addEventListener('storage', checkSession);
    return () => window.removeEventListener('storage', checkSession);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) { navigate(`/shop?search=${encodeURIComponent(search.trim())}`); setSearch(''); }
  };

  return (
    <>
      {/* ── Ticker ── */}
      <div className="ticker-wrap">
        <div className="ticker-track">
          {[...TICKER_ITEMS, ...TICKER_ITEMS].map((t, i) => (
            <span key={i}><span className="t-item">{t}</span><span className="t-sep"> ✦ </span></span>
          ))}
        </div>
      </div>

      {/* ── Header ── */}
      <header style={{
        position:'sticky',top:0,zIndex:200,
        background:'linear-gradient(180deg,rgba(13,5,0,.98) 0%,rgba(26,10,46,.96) 100%)',
        borderBottom:'1px solid rgba(255,184,0,.25)',backdropFilter:'blur(14px)',
      }}>
        <div style={{maxWidth:1300,margin:'0 auto',padding:'0 1.5rem',display:'flex',alignItems:'center',justifyContent:'space-between',height:66,gap:'1rem'}}>

          {/* Logo */}
          <Link to="/" style={{display:'flex',alignItems:'center',gap:'.5rem',textDecoration:'none',flexShrink:0}}>
            <span className="om-glow" style={{fontSize:'1.9rem'}}>ॐ</span>
            <span style={{
              fontFamily:"'Cinzel Decorative',serif",fontSize:'1.15rem',fontWeight:700,
              background:'linear-gradient(135deg,#FFE082,#FF6B00)',
              WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',
            }}>CosmicHindu</span>
          </Link>

          {/* Nav */}
          <nav style={{display:'flex',gap:'1.4rem',alignItems:'center'}}>
            {[
              {to:'/',l:'Home'},
              {to:'/shop',l:'🛍 Sacred Shop'},
              {to:'/about',l:'About'},
              {to:'/contact',l:'Contact'},
            ].map(({to,l})=>(
              <Link key={l} to={to} style={{
                fontFamily:"'Cinzel',serif",fontSize:'.7rem',fontWeight:500,
                letterSpacing:'.1em',textTransform:'uppercase',
                color:'#F5E6C8',textDecoration:'none',transition:'color .25s',
              }}>{l}</Link>
            ))}
          </nav>

          {/* Right */}
          <div style={{display:'flex',alignItems:'center',gap:'.7rem',flexShrink:0}}>
            <form onSubmit={handleSearch}>
              <input
                value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search…"
                style={{
                  background:'rgba(255,184,0,.1)',border:'1px solid rgba(255,184,0,.28)',
                  color:'#FFE082',borderRadius:20,padding:'.3rem .85rem',
                  fontFamily:"'Crimson Pro',serif",fontSize:'.9rem',outline:'none',
                  transition:'all .25s',width:140,
                }}
              />
            </form>
            {customerName ? (
              <Link to="/account/dashboard" style={{
                fontFamily:"'Cinzel',serif",fontSize:'.65rem',letterSpacing:'.1em',
                textTransform:'uppercase',textDecoration:'none',
                padding:'.35rem .75rem',borderRadius:20,transition:'all .2s',
                background:'linear-gradient(135deg,rgba(255,107,0,.18),rgba(255,184,0,.18))',
                border:'1px solid rgba(255,184,0,.45)',
                color:'#FFE082',
              }}>👤 {customerName}</Link>
            ) : (
              <Link to="/account" style={{
                fontFamily:"'Cinzel',serif",fontSize:'.65rem',letterSpacing:'.1em',
                textTransform:'uppercase',color:'rgba(255,224,130,.65)',textDecoration:'none',
                padding:'.35rem .75rem',border:'1px solid rgba(255,184,0,.22)',borderRadius:20,
                transition:'all .2s',
              }}>👤 Account</Link>
            )}
            <button onClick={()=>setCartOpen(true)} style={{
              position:'relative',
              background:'linear-gradient(135deg,#FF6B00,#FFB800)',
              border:'none',borderRadius:22,padding:'.4rem 1rem .4rem .8rem',
              display:'flex',alignItems:'center',gap:'.4rem',cursor:'pointer',
              fontFamily:"'Cinzel',serif",fontSize:'.7rem',fontWeight:600,
              letterSpacing:'.08em',color:'#0D0500',
              transition:'transform .2s,box-shadow .2s',
            }}>
              🛒 Cart
              {itemCount > 0 && (
                <span style={{
                  background:'#C0392B',color:'#fff',borderRadius:'50%',
                  minWidth:18,height:18,fontSize:'.62rem',fontWeight:700,
                  display:'flex',alignItems:'center',justifyContent:'center',
                  position:'absolute',top:-7,right:-7,
                  padding:'0 4px',boxSizing:'border-box',
                  boxShadow:'0 0 0 2px rgba(13,5,0,.9)',
                  animation:'cart-pop .25s ease',
                }}>{itemCount > 99 ? '99+' : itemCount}</span>
              )}
            </button>
          </div>
        </div>
      </header>

      <CartSidebar open={cartOpen} onClose={()=>setCartOpen(false)} />
    </>
  );
}
